var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "m-4 jumbotron jumbotron-fluid text-center"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {}, [_c('b-icon', {
    attrs: {
      "icon": "cart-check",
      "animation": "throb",
      "aria-hidden": "true"
    }
  }), _vm._v(" Compra realizada con exito ")], 1)])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }